var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "tags",
      class: {
        isEmpty:
          _vm.articlePrimaryKeywordData.length === 0 &&
          _vm.articleSeriesKeywordData.length === 0 &&
          _vm.articleSequencingKeywordData.length === 0
      }
    },
    [
      _vm._l(_vm.articlePrimaryKeywordData, function(
        primaryKeyword,
        primaryKeywordIndex
      ) {
        return [
          _c(
            "router-link",
            {
              staticClass: "tag",
              attrs: { to: "/thema/" + encodeURIComponent(primaryKeyword.name) }
            },
            [
              _c("button", {
                staticClass: "btn btn-pink-white-black-white",
                domProps: { innerHTML: _vm._s(primaryKeyword.name) }
              })
            ]
          )
        ]
      }),
      _vm._v(" "),
      _vm._l(_vm.articleSeriesKeywordData, function(
        seriesKeyword,
        seriesKeywordIndex
      ) {
        return [
          _c(
            "router-link",
            {
              staticClass: "tag",
              attrs: { to: "/thema/" + encodeURIComponent(seriesKeyword.name) }
            },
            [
              _c("button", {
                staticClass: "btn btn-pink-white-black-white",
                domProps: { innerHTML: _vm._s(seriesKeyword.name) }
              })
            ]
          )
        ]
      }),
      _vm._v(" "),
      _vm._l(_vm.articleSequencingKeywordData, function(
        sequencingKeyword,
        sequencingKeywordIndex
      ) {
        return [
          _c(
            "router-link",
            {
              staticClass: "tag",
              attrs: {
                to: "/thema/" + encodeURIComponent(sequencingKeyword.name)
              }
            },
            [
              _c("button", {
                staticClass: "btn btn-pink-white-black-white",
                domProps: { innerHTML: _vm._s(sequencingKeyword.name) }
              })
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5af78194", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af78194","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Tags.vue
// module id = 543
// module chunks = 0